import { load as loadYAML, dump as dumpYAML } from "js-yaml";
import { base64ToUint8Array, uint8ArrayToBase64, zstdCompressString, zstdDecompressString } from "./funcZstd";
export const API_VERSION = 2;
export const CONTROL_CONF_LIST = [
    {
        conf_name: 'skill-passive',
        control_switch_element_id: 'OBJID_CHECK_A1_SKILL_SW',
        type: 'support'
    },
    {
        conf_name: 'skill-1st',
        control_switch_element_id: 'OBJID_CONTROL_CONF_0_SWITCH',
        type: 'support'
    },
    {
        conf_name: 'skill-2nd',
        control_switch_element_id: 'OBJID_CONTROL_CONF_1_SWITCH',
        type: 'support'
    },
    {
        conf_name: 'skill-3rd',
        control_switch_element_id: 'OBJID_CONTROL_CONF_2_SWITCH',
        type: 'support'
    },
    {
        conf_name: 'skill-4th',
        control_switch_element_id: 'OBJID_CONTROL_CONF_3_SWITCH',
        type: 'support'
    },
    {
        conf_name: 'debuff',
        control_switch_element_id: 'OBJID_CONTROL_CONF_4_SWITCH',
        type: 'support'
    },
    {
        conf_name: 'status-basic',
        control_switch_element_id: 'OBJID_CONTROL_CONF_5_SWITCH',
        type: 'customize'
    },
    {
        conf_name: 'attack',
        control_switch_element_id: 'OBJID_CONTROL_CONF_6_SWITCH',
        type: 'customize'
    },
    {
        conf_name: 'defense',
        control_switch_element_id: 'OBJID_CONTROL_CONF_7_SWITCH',
        type: 'customize'
    },
    {
        conf_name: 'skill',
        control_switch_element_id: 'OBJID_CONTROL_CONF_8_SWITCH',
        type: 'customize'
    },
    {
        conf_name: 'status-special',
        control_switch_element_id: 'OBJID_CONTROL_CONF_9_SWITCH',
        type: 'customize'
    }
];
// Decode => 展開 => YAML load
export async function decodeProcess(encodedData) {
    let dataObject = null;
    try {
        // デコード => 圧縮データ
        const compressedData = base64ToUint8Array(encodedData);
        // zstdで展開
        const yamlData = await zstdDecompressString(compressedData);
        if (yamlData) {
            //console.debug(yamlData);
            // YAML文字列 => JavaScriptオブジェクト
            dataObject = loadYAML(yamlData);
        }
    }
    catch (error) {
        console.error("エラーが発生しました:", error);
    }
    return dataObject;
}
// YAML dump => 圧縮 => Encode
export async function encodeProcess(dataObject) {
    let encodedData = null;
    try {
        // YAMLオブジェクト => YAML文字列
        const yamlData = dumpYAML(dataObject);
        // zstdで圧縮
        const compressedData = await zstdCompressString(yamlData);
        if (compressedData) {
            // 圧縮データ => 文字列
            encodedData = uint8ArrayToBase64(compressedData);
        }
    }
    catch (error) {
        console.error("エラーが発生しました:", error);
    }
    return encodedData;
}
